import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, FlexContainer } from "heliocor-ui"
import CommonTitle from "../../../common/CommonTitle"

const SectionWrapper = ({id, title, handleChangeStep, canEdit = false, children}) => {
    const { t } = useTranslation()

    return (
        <FlexContainer column data-cy={id}>
            <FlexContainer alignItems="center">
                <CommonTitle value={t(title)} padding='1rem 1rem .5rem' />
                {handleChangeStep && canEdit && (
                    <Button
                        data-cy="editButton"
                        type='light'
                        value={t('edit')}
                        onClick={() => handleChangeStep(title)} 
                    />
                )}
            </FlexContainer>
            <FlexContainer column padding="0 1rem">
                {children}
            </FlexContainer>
        </FlexContainer>
    )
}

export { SectionWrapper }